export default __webpack_public_path__ + "static/kpi-banner-3ad4d128292310953a11dca81a578acb.jpg";